import { selfApi } from '@/shared/lib/api'

import { ENABLED_PROVIDERS } from './constants'

import type { AuthProviderConfig } from './types'

/**
 * Configuração do módulo de autenticação.
 *
 * Migrado de `config.js` sem alteração de valores, com uma adição: a chave
 * `confirmation`, que não existia — por isso `/auth/confirmation` abria um campo
 * de token sem título nem orientação.
 */
const getConfig = (props: Partial<AuthProviderConfig> = {}): AuthProviderConfig => {
  const { afterSignInRedirectUrl, ...rest } = props

  return {
    httpClient: selfApi,
    afterSignInRedirectUrl,
    disableReCaptcha: true,
    customNavigation: false,
    enabledProviders: ENABLED_PROVIDERS,
    styleConfig: {
      solid: false
    },
    config: {
      signIn: {
        loginLabel: 'E-mail',
        header: {
          title: 'Entre',
          subtitle: 'Use suas credenciais de acesso'
        }
      },
      signUp: {
        header: {
          title: 'Cadastre-se',
          subtitle: 'Rápido, fácil e grátis'
        }
      },
      forgotPassword: {
        header: {
          title: 'Esqueceu a senha?',
          subtitle: 'Digite seu e-mail e resete sua senha'
        }
      },
      resetPassword: {
        header: {
          title: 'Resetar senha',
          subtitle: 'Digite sua nova senha para resetar'
        }
      },
      confirmation: {
        header: {
          title: 'Confirmar conta',
          subtitle: 'Digite o código que enviamos para o seu e-mail'
        }
      },
      resendConfirmation: {
        header: {
          title: 'Confirmar conta',
          subtitle:
            'Digite seu e-mail para solicitar um novo código de confirmação'
        }
      }
    },
    ...rest
  }
}

export default getConfig
export { getConfig }
